import React from 'react';
import { ThemeProvider } from '@fairygodboss/ui';
import { ContentBody } from './ContentBody/ContentBody';
import { Comments } from '../SharedComponents/Comments/Comments';
import { RecentPosts } from './RecentPosts/RecentPosts';
import { BottomConvincer } from './BottomConvincer/BottomConvincer';
import { useCommunityContent } from './CommunityPostContentContext';
import { ResetStyle } from '../SharedComponents/ResetStyle';

export const CommunityPostDisplayPage = () => {
    const { deleted } = useCommunityContent();
    return (
        <ResetStyle>
            <ThemeProvider>
                <ContentBody />
                {!deleted ? <Comments context={useCommunityContent} /> : null}
                <RecentPosts />
                <BottomConvincer />
            </ThemeProvider>
        </ResetStyle>
    );
};
